var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"btc-main"},[_c('el-header',[_c('Header')],1),_c('el-main',{staticClass:"btc-column-main"},[_c('router-view',{ref:"btc_main"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }